import ecommerceImg from '../images/service-single/ecommerce.png'
import headlessImg from '../images/service-single/headless.png'
import maintenanceImg from '../images/service-single/maintenance.png'
import seoImg from '../images/service-single/seo.png'
import landingImg from '../images/service-single/landing.png'
import appImg from '../images/service-single/app.png'

import sideTech1 from '../images/service-single/side_tech_1.png'
import sideTech2 from '../images/service-single/side_tech_2.png'
import sideTech3 from '../images/service-single/side_tech_3.png'
import sideTech4 from '../images/service-single/side_tech_4.png'

const Services = [
    {
        Id: '1',
        sImgS: ecommerceImg,
        sTitle: 'Website E-Commerce',
        description: 'We build robust, fast, and sales-optimized online stores using Shopify or WooCommerce. Engineered to help your business generate revenue automatically 24/7.',
        des2: 'We build robust, fast, and sales-optimized online stores.',
        des3: 'At Abdul Cholik Studio, we design and engineer e-commerce platforms that are not only visually stunning but also technically optimized for high Conversion Rate Optimization (CRO). Leveraging the reliability of Shopify or the extreme flexibility of WooCommerce, we ensure seamless payment gateways, localized shipping calculators, real-time inventory management, and an exceptional user experience (UX) across all devices. We deliver high-performing storefronts primed to convert traffic into sales from day one.',
        capabilities: [
            'Custom modern UI/UX design tailored for conversion',
            'Secure integration of local and international payment gateways',
            'Automated shipping rate calculators & local courier integration',
            'Page-speed optimization and advanced customer data security'
        ],
        approach: 'Our approach centers on frictionless navigation and checkout security. We believe a successful online store must be incredibly fast, trustworthy, and simple to navigate, minimizing cart abandonment at every step.',
        process: [
            'In-depth discovery session to analyze your products, target market, and goals.',
            'Interactive UI/UX mockup design and user journey mapping.',
            'Full-stack development, database integration, payment, and shipping setup.',
            'Rigorous speed, security, and multi-device responsiveness testing.',
            'Official launch with handover documentation and CMS administration training.'
        ],
        icon: 'flaticon-promotion',
        projects: '124',
        ssImg1: ecommerceImg,
        ssImg2: sideTech4,
    },
    {
        Id: '2',
        sImgS: headlessImg,
        sTitle: 'WordPress Headless CMS',
        description: 'Combine the intuitive content management of WordPress with the blazing-fast performance of React frontends like Next.js or Gatsby. Bulletproof security with no exposed database.',
        des2: 'Combine the intuitive management of WordPress with the speed of Next.js or Gatsby.',
        des3: 'Headless CMS architecture represents the cutting-edge of web development. We decouple the WordPress backend (giving you a familiar, powerful editor for content) from the public-facing website, which we build using modern frontend technologies like Next.js, Gatsby, or Astro. The result is a website with sub-second page loads, flawless Core Web Vitals, perfect SEO rankings, and bulletproof security because your administrative database is entirely hidden from the public web. Ideal for businesses demanding absolute top-tier web performance.',
        capabilities: [
            'Decoupled JAMstack architecture using Next.js, Gatsby, or Astro',
            'GraphQL / REST API integration for ultra-fast, structured data loading',
            'Static Site Generation (SSG) for absolute bulletproof security',
            'Optimized asset delivery via Global Edge Networks (CDN)'
        ],
        approach: 'We target extreme speed and high security. By decoupling the presentation layer from the content, we eliminate traditional WordPress vulnerabilities and ensure page loads are virtually instantaneous.',
        process: [
            'Designing database schemas and content modeling inside WordPress.',
            'Engineering the frontend architecture using Next.js or Gatsby.',
            'Integrating data streams via secure GraphQL or REST API endpoints.',
            'Optimizing Core Web Vitals and performing security audits.',
            'Deploying static assets to globally distributed edge networks like Vercel or Netlify.'
        ],
        icon: 'flaticon-coding',
        projects: '85',
        ssImg1: headlessImg,
        ssImg2: sideTech1,
    },
    {
        Id: '3',
        sImgS: maintenanceImg,
        sTitle: 'Website Maintenance & Support',
        description: 'Ongoing proactive care to keep your website highly secure, lightning-fast, malware-free, and fully updated. Fast-response technical support whenever you need it.',
        des2: 'Ongoing proactive care to keep your website secure, fast, and fully updated.',
        des3: 'Websites require regular, specialized maintenance to stay secure against emerging cyber threats, prevent system downtime, and resolve software conflicts. Our Website Maintenance & Support service provides complete peace of mind. We handle core updates, plugin audits, automated encrypted daily cloud backups, routine malware scans, and continuous speed optimization. With our highly responsive team at your disposal, you can focus 100% on growing your business while we handle the technology.',
        capabilities: [
            'Safe, routinely tested updates of CMS cores, plugins, and active themes',
            'Automated daily/weekly encrypted backups to off-site cloud storage',
            'Proactive Web Application Firewall (WAF) setup & malware removal',
            'On-demand bug fixes, layout corrections, and rapid tech support'
        ],
        approach: 'We believe in proactive prevention over reactive fixes. We actively monitor, update, and shield your website daily to identify and resolve potential issues before they ever impact your visitors or disrupt your business.',
        process: [
            'Comprehensive initial audit to detect hidden bugs, malware, and database bloat.',
            'Setting up secure cloud backup pipelines and custom security firewalls.',
            'Performing daily uptime monitoring and routine monthly core upgrades.',
            'Delivering transparent monthly reports detailing work done, security status, and speed stats.'
        ],
        icon: 'flaticon-verified',
        projects: '520',
        ssImg1: maintenanceImg,
        ssImg2: sideTech3,
    },
    {
        Id: '4',
        sImgS: seoImg,
        sTitle: 'SEO & GEO Optimization',
        description: 'Dominate standard search engines and modern AI generative search tools. We optimize your brand to be highly recommended by Gemini, ChatGPT, Perplexity, and Google Search.',
        des2: 'Optimizing your brand for Google Search and AI engines like Gemini and ChatGPT.',
        des3: 'Modern search is shifting. Generative Engine Optimization (GEO) is the crucial practice of optimizing your website\'s content and structure to ensure AI generative engines—such as Gemini, ChatGPT, Perplexity, and Claude—cite and recommend your brand. Combined with standard Search Engine Optimization (SEO), we build a bulletproof search presence that captures both traditional searchers and the growing volume of users seeking answers from generative AI engines.',
        capabilities: [
            'AI Engine visibility audits (Gemini, ChatGPT, Perplexity, Claude)',
            'Keyword intent semantic optimization for natural language queries',
            'High-authority citations, structured data, and source credibility indexing',
            'On-page SEO, Core Web Vitals, and technical website architecture'
        ],
        approach: 'We optimize for both bots and AI LLMs. We leverage authority building, exact semantic matching, and clear structural data so that AI models easily parse and confidently recommend your services to user queries.',
        process: [
            'Conducting a GEO audit to see how AI engines currently summarize and cite your brand.',
            'Optimizing copy and structure to match natural conversational question queries.',
            'Creating structured schema markups, semantic content hubs, and authoritative citations.',
            'Executing standard technical SEO optimizations for indexing.',
            'Continuous tracking of organic search traffic and AI engine citation performance.'
        ],
        icon: 'flaticon-bar-chart',
        projects: '92',
        ssImg1: seoImg,
        ssImg2: sideTech4,
    },
    {
        Id: '5',
        sImgS: landingImg,
        sTitle: 'Landing Page',
        description: 'High-converting landing pages specifically designed for Google Ads, Facebook, or Instagram campaigns. Dibuat menarik to capture leads and convert visitors.',
        des2: 'High-converting landing pages specifically designed for your ad campaigns.',
        des3: 'Maximize the ROI of your ad spend with precision-engineered, high-converting Landing Pages. We build custom pages designed around a single, clear Call-to-Action (CTA)—whether it is capturing email leads, driving form submissions, or triggering direct WhatsApp inquiries. By combining conversion-centered UI design, persuasive sales copywriting, clean aesthetics, and sub-second load times, we ensure every marketing dollar you spend has the highest probability of yielding results.',
        capabilities: [
            'Modern, focused layouts designed for Conversion Rate Optimization (CRO)',
            'Persuasive, highly focused sales copywriting that triggers action',
            'Ultra-lightweight development to ensure load times under 1 second',
            'Seamless contact form and direct WhatsApp chat integration'
        ],
        approach: 'Our philosophy is simplicity and clarity. We eliminate distractions, clarify the value proposition within the first 3 seconds, and guide the visitor\'s eye naturally toward the primary Call to Action.',
        process: [
            'Analyzing your product or service, target demographics, and advertising channels.',
            'Developing a high-converting content layout and wireframe.',
            'Crafting persuasive copy and designing premium, modern UI assets.',
            'Optimizing the loading speed and testing form response handling.',
            'Integrating campaign tracking pixels (Google Tag, Facebook Pixel) and launching.'
        ],
        icon: 'flaticon-palette',
        projects: '180',
        ssImg1: landingImg,
        ssImg2: sideTech2,
    },
    {
        Id: '6',
        sImgS: appImg,
        sTitle: 'Android & iOS Application',
        description: 'Expand your business to mobile platforms with highly responsive native or hybrid applications (Flutter/React Native) published directly on the Google Play Store & App Store.',
        des2: 'Native or hybrid mobile applications published directly on the App Store & Play Store.',
        des3: 'Put your brand directly in your customers\' hands with a custom mobile application for iOS and Android. At Abdul Cholik Studio, we build mobile apps that are highly responsive, smooth in transition, and beautiful to navigate. Using cross-platform frameworks like Flutter or React Native, we deliver budget-efficient apps that look and feel completely native. We guide you from initial UI/UX mockups all the way through backend API integration and final publication to the App Store and Google Play Store.',
        capabilities: [
            'Cross-platform app development (Flutter / React Native) for cost efficiency',
            'Modern, ergonomic, and aesthetic UI/UX mobile app interface design',
            'Real-time database synchronizations, push notifications, and payment gateways',
            'Full App Store and Google Play Store submission & publishing management'
        ],
        approach: 'We build with a user-centric focus. We prioritize native touch responses, high-performance transitions, optimized device battery usage, and secure end-to-end data encryption.',
        process: [
            'Scoping app features, compiling user stories, and creating screen wireframes.',
            'Designing high-fidelity interactive UI mockups in Figma.',
            'Frontend mobile coding and secure RESTful API backend development.',
            'Rigorous multi-device performance, beta-testing, and debugging.',
            'Managing the entire listing, review, and launch process on the App Stores.'
        ],
        icon: 'flaticon-smartphone',
        projects: '38',
        ssImg1: appImg,
        ssImg2: sideTech2,
    }
]

export default Services;